import { CUSTOMER_JOURNEY_RESERVATION, CUSTOMER_JOURNEY_RESERVATION_SUCCESS, CUSTOMER_JOURNEY_RESERVATION_ERROR } from './../../actions/const';
import { CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE, CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_SUCCESS, CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_ERROR } from './../../actions/const';
import { SET_TOKEN, SET_LANG } from './../../actions/const';

import CustomerJourneySource from './../../sources/CustomerJourneySource';

import defer from 'lodash/defer';

const initialState = {
  apiData: {},
  loading: false
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case SET_TOKEN:
    case SET_LANG:
    case CUSTOMER_JOURNEY_RESERVATION: {
      nextState.loading = true;
      CustomerJourneySource.reservation(action.token, action.lang, action.context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_RESERVATION_SUCCESS: {
      nextState.loading = false;
      nextState.apiData = action.data;
      return nextState;
    }
    case CUSTOMER_JOURNEY_RESERVATION_ERROR: {
      nextState.loading = false;
      nextState.apiData = {};
      return nextState;
    }
    case CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE: {
      nextState.loading = true;
      
      if (nextState.apiData.mail_subscription_active) {
        CustomerJourneySource.unsubscribe_mail(action.token, action.lang, action.successCallback, action.errorCallback);
      }
      else {
        CustomerJourneySource.subscribe_mail(action.token, action.lang, action.successCallback, action.errorCallback);
      }

      return nextState;
    }
    case CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_SUCCESS: {

      if (action.successCallback) defer(action.successCallback, action.data);

      nextState.loading = false;
      nextState.apiData.mail_subscription_active = !nextState.apiData.mail_subscription_active
      return nextState;
    }
    case CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_ERROR: {

      if (action.errorCallback) defer(action.errorCallback);

      nextState.loading = false;
      return nextState;
    }
    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/reservation.js